import { useState } from 'react';

import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Tab2 from './Tab2';
const Tab1 = ({ SerialNo, ItemCode }) => {
  return (
    <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>

      <div className="col-6 ">
        <div className="mb-3">
          <Input
            id="SerialNo"
            label="Serial No"
            style={{
              height: "30px",
              border: SerialNo?.Error ? "1px solid red" : "",
            }}
            value={SerialNo?.SerialNo || ""}
            onChange={(e) => SerialNo?.setSerialNo?.(e.target.value)}
          />
        </div>
      </div>

      <div className="col-6">
        <div className={ItemCode.Error ? `mb-3 errorborder` : `mb-3`}>
          <SelectSearch
  list={ItemCode.ItemCode_list}
  label="Item Code"
  getOptionLabel={(item) =>
    item.isNew ? "+ Create New Item Code" : item.name
  }
  getOptionValue={(item) => item.name}
  value={ItemCode.select_ItemCode}
  onChange={(val) => ItemCode.setselect_ItemCode(val)}
  createNewUrl="/master/item/create-item"
  createNewLabel="Create New Item Code"
/>
         
        </div>
      </div>
      
    </div>
   
  );
};

export default Tab1;